import getStore from '../store/configureStore';
import _get from 'lodash/get';

export function getDonateButtonImageUrl(buttonSize, showAcceptedCardLogos, languageCode, countryCode) {
	const reduxStore = getStore();
	const countryAndLanguageDetails = _get(reduxStore.getState(), 'application.countryAndLanguageDetails');
	let url = _get(countryAndLanguageDetails, `countriesByCode.${countryCode}.languages.${languageCode}.buttonImageUrl`, {});

	if (buttonSize === 'large') {
		if (showAcceptedCardLogos) {
			url = url.cc;
		} else {
			url = url.large;
		}
	} else {
		url = url.small;
	}

	return url;
}



// WEBPACK FOOTER //
// ./buttons/utils/buttonImage.js